import { render, staticRenderFns } from "./Gewichtsverlust.vue?vue&type=template&id=6be407fc&"
import script from "./Gewichtsverlust.vue?vue&type=script&lang=js&"
export * from "./Gewichtsverlust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports